import React, { Component, Fragment } from "react";

import "./ImageList.css";

const UP = -1
const DOWN = 1

class ImageList extends Component {


   render() {
      const {imageList, onMove, onRemove, onFlag, onDragOver, onDragStart, onDragEnd} = this.props

      return (


       <Fragment>
           <ul id="imagesContainer" className={["mn-content-upload__gallery-list", imageList.length == 0 ? "uk-sortable-empty" : "", ].join(" ")}>
                {imageList.map((item, index) =>
                    <li key={item.id} 
                    className={["mn-content-upload__gallery-row", 
                    // index == 1 ? "has-error" : "", 
                    index == 1 ? "first" : "", 
                    imageList.length == index+1 ? "last" : "", 
                    item.primery ? "primary" : "", 
                     ].join(" ")}  id="1YGiO" onDragOver={() => onDragOver(item.id)} >
                        <input type="hidden" className="js-image-id-input" name="images[images][]" value="1YGiO"/>
                        <div className="mn-content-upload__img-container">
                            <img src={item.image} alt="" className="mn-content-upload__img js-upload-thumb"/>
                            <div className="mn-content-upload__img-loader" style={{ display: "none" }}>
                                <div className="progress__wrapper"> 
                                    <span className="progress"></span>
                                </div>
                            </div>
                            <div className="mn-content-upload__img-error"></div>
                        </div>
                        <div className="mn-content-upload__mid-container">
                            <div className="mn-content-upload__mid-container mn-content-upload__mid-container--top">
                                <div className="mn-content-upload__desc">
                                    <div className="mn-content-upload__desmn--top">
                                        <div className="right">
                                            <div className="mn-content-upload__name js-upload-name">{item.name}</div>
                                            <div className="mn-content-upload__size js-upload-size">{item.size}</div>
                                        </div>
                                        <div className="mn-content-upload__select"></div>
                                    </div>
                                </div>
                                <ul className="mn-content-upload__list mn-content-upload__list--errors js-upload-error-list"></ul>
                            </div>
                        </div>
                        <div className="mn-content-upload__controls">
                            {/* <button type="button" className="mn-content-upload__btn mn-content-upload__btn--refresh js-refresh-upload"></button> */}
                            <button type="button" className="mn-content-upload__btn mn-content-upload__btn--flag js-flag-primary js-tooltip" onClick={() => onFlag(item.id)} data-tooltip="از این پرچم برای انتخاب تصویر اصلی استفاده کنید"></button>
                            {/* <button type="button" className="mn-content-upload__btn mn-content-upload__btn--cancel js-cancel-upload"></button> */}
                            <button type="button" className="mn-content-upload__btn mn-content-upload__btn--remove" onClick={() => onRemove(item.id)}></button>
                            {/* <button type="button" className="mn-content-upload__btn mn-content-upload__btn--undo js-undo-remove"></button> */}
                            <div className="mn-content-upload__drag-handler mn-content-upload__drag-handler--outer"> 
                                <span className="mn-content-upload__drag-handler mn-content-upload__drag-handler--up" onClick={() => onMove(item.id, UP)}></span>
                                <span className="mn-content-upload__drag-handler mn-content-upload__drag-handler--bg" onDragStart={event => onDragStart(event, item.id)} draggable onDragEnd={onDragEnd}></span>
                                <span className="mn-content-upload__drag-handler mn-content-upload__drag-handler--down" onClick={() => onMove(item.id, DOWN)}></span>
                            </div>
                        </div>
                    </li>
                )}
            </ul>
            <div type="button" className="mn-content-upload__show-more hidden">بیشتر</div>
       </Fragment>
      );
   }
}

export default ImageList;


{/* <li className="mn-content-upload__gallery-row js-uploads-row primary " id="1YGhm">
                    
                </li>
                <li className="mn-content-upload__gallery-row js-uploads-row first " id="1YGhm">
                    
                </li>
                <li className="mn-content-upload__gallery-row js-uploads-row " id="1YGhm">
                    
                </li>
                <li className="mn-content-upload__gallery-row js-uploads-row last" id="1YGhm">
                    
                </li> */}



                // {"status":true,"data":{"id":"1YQVI","url":"https:\/\/dkstatics-public.digikala.com\/digikala-products\/27d85d4fcb1f179f5bffa2ac29126083979d2dd5_1630878283.jpg?x-oss-process=image\/resize,m_fill,h_90,w_90","tempFile":true,"slot":"1"}}
                // {"status":true,"data":{"errors":{"error":"\u062d\u062f\u0627\u06a9\u062b\u0631 \u0639\u0631\u0636 \u0628\u0631\u0627\u06cc \u0622\u067e\u0644\u0648\u062f \u0639\u06a9\u0633 \u0645\u06cc\u200c\u062a\u0648\u0627\u0646\u062f 2500 \u067e\u06cc\u06a9\u0633\u0644 \u0628\u0627\u0634\u062f"},"slot":"2"}}
                // {"status":true,"data":{"errors":{"error":"\u0646\u0633\u0628\u062a \u0637\u0648\u0644 \u0648 \u0639\u0631\u0636 \u062a\u0635\u0648\u06cc\u0631 1 \u0628\u0647 1 \u0646\u06cc\u0633\u062a"},"slot":"3"}}
                // {"status":true,"data":{"id":"1ZHRG","url":"https:\/\/dkstatics-public.digikala.com\/digikala-products\/910183db5e68bd41711f9d5a1122e541d033eb9f_1631129207.jpg?x-oss-process=image\/resize,m_fill,h_90,w_90","tempFile":true,"slot":"2"}}
                // {"status":true,"data":{"id":"1ZHS4","url":"https:\/\/dkstatics-public.digikala.com\/digikala-products\/3baa410607bb1f86bdfb45dc63a703056cb975e6_1631129234.jpg?x-oss-process=image\/resize,m_fill,h_90,w_90","tempFile":true,"slot":"3"}}
